import { CountryService } from "../services/common/CountryService";
import { format } from "date-fns";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

export const useNavigateToLogout = () => {
	const navigate = useNavigate();

	const NavigateToLogout = (path: string): void => {
	
		navigate(path);
	};

	return NavigateToLogout;
};

export const toCamelCase = (str: string): string =>
	str
		.trim()
		.split(/\s+/)
		.map((word, i) =>
			i === 0
				? word.toLowerCase()
				: word[0].toUpperCase() + word.slice(1).toLowerCase()
		)
		.join("");

export const formatDate = (datee: any) => {

	if (datee !== "" && datee !== null) {
		const date = new Date(datee);
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, "0");
		const day = String(date.getDate()).padStart(2, "0");
		const formattedDate = `${year}-${month}-${day}`;

		return formattedDate;
	} else {
		return null;
	}
};

export const formatDateToShow = (datee: any) => {
	if (datee !== "" && datee !== null) {
		const originalDate = new Date(datee);
		const formattedDate = format(originalDate, "MMM dd, yyyy");
		// const formattedDate = format(originalDate, "M dd, yy");
		return formattedDate;
	} else {
		return "";
	}
};

export const checkSINValidity = (inputNumber: string | any): number => {
	let result = 0;
	if (inputNumber) {
		for (let i = 0; i < inputNumber.length; i++) {
			const digit = parseInt(inputNumber[i], 10);

			// Multiply even digits by 2 and odd digits by 1
			let j = i + 1;
			const multiplier = j % 2 === 0 ? 2 : 1;
			const product = digit * multiplier;

			if (product.toString().length > 1) {
				const sumOfDigits = product
					.toString()
					.split("")
					.reduce((sum, num) => sum + parseInt(num, 10), 0);
				result += sumOfDigits;
			} else {
				result += product;
			}
		}
	}
	return result;
};

export const sortData = (data: any[]): any[] => {
	return data.sort((a, b) => a.label.localeCompare(b.label));
};
export const sortDDLByLabel = (data: any[]): any[] => {
	return data.sort((a, b) => a.label.localeCompare(b.label));
};
export const formatPhoneNo = (phone: any) => {
	if (phone && phone !== null && typeof phone === "string") {
		return phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
	} else {
		return phone;
	}
};

export const formatThousandSeperatorWithTwoFixedAmount = (
	value: number | null | string
) => {
	if (typeof value === "string") {
		return value;
	} else if (value && value !== null) {
		return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	} else {
		return value;
	}
};

export const format422Errors = (errors: any) => {
	return errors.detail
		.map((error: any, index: any) => {
			// Extract the last key in the `loc` array as the field name
			const field = error.loc[error.loc.length - 1];
			// return `${index + 1}. ${field} ${error.msg}, `;
			return `${field} ${error.msg}, `;
		})
		.join("\n");
};

export const createRandomId = () => {
	let id = "";
	let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

	for (let i = 0; i < 5; i++) {
		id += chars.charAt(Math.floor(Math.random() * chars.length));
	}

	return id;
};

export const addDashesInSIN = (sin: string) => {
	if (!sin) return "";
	const numericValue = sin.replace(/\D/g, "");
	const maxLength = Math.min(numericValue.length, 9);
	let formattedValue = "";

	for (let i = 0; i < maxLength; i++) {
		if (i === 3 || i === 6) formattedValue += "-";
		formattedValue += numericValue.charAt(i);
	}

	return formattedValue;
};

export const SINInputCell = ({
	rowData,
	rowIndex,
	field,
	tableData,
	setTableData,
	renderErrorClass,
}: {
	rowData: any;
	rowIndex: number;
	field: any;
	tableData: any[];
	setTableData: React.Dispatch<React.SetStateAction<any[]>>;
	renderErrorClass: (field: any, rowIndex: number, rowData: any) => string;
}) => {
	const [formattedValue, setFormattedValue] = useState(() =>
		addDashesInSIN(rowData.socialInsurance)
	);

	const handleValueChange = (value: string) => {
		const updatedValue = addDashesInSIN(value);
		setFormattedValue(updatedValue);

		const updatedData = [...tableData];
		updatedData[rowIndex][field.field] = value;
		setTableData(updatedData);
	};

	return (
		<input
			type="text"
			className={renderErrorClass(field, rowIndex, rowData)}
			value={formattedValue}
			onChange={(e) => handleValueChange(e.target.value)}
			maxLength={11}
			style={{ padding: "0.85rem" }}
		/>
	);
};

export enum EnhancedButtonPrimeReactSeverity {
	Primary = "", //blue
	Secondary = "secondary", //grey
	Success = "success", // greem
	Info = "info", //blue
	Warning = "warning", //musturd
	Help = "help", //purple
	Danger = "danger", //red
}


export const formatAmountCommaSeperator = (amount: number | string) => {
	if (amount == null || amount === "") return "0.00";
	const num = parseFloat(amount.toString());
	if (isNaN(num)) return "0.00";
	return num
		.toFixed(2) // 2 decimal places
		.replace(/\B(?=(\d{3})+(?!\d))/g, ","); // comma separation
};

export const formatAmountToFloat = (amount: string) => {
	if (!amount) return 0;
	const cleaned = amount.replace(/[^0-9.-]/g, "");
	const num = parseFloat(cleaned);
	return isNaN(num) ? 0 : num;
};

// PrimeReact DataTable → when you navigate back, it first flashes the old cached rows, then replaces them after the API finishes → ❌ not what you want.

// That happens because PrimeReact DataTable is controlled by the value prop. If you’re holding rows in state and not clearing them when you leave/unmount the screen, it will re-render with old data immediately.
export const useRemoveQueriesOnUnmount = (queryKeys: string[]) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    return () => {
      queryKeys.forEach((key) => {
        queryClient.removeQueries({ queryKey: [key] });
      });
    };
    // ✅ queryKeys is a stable array of strings, so no loop
  }, [queryClient, queryKeys.join("|")]);
};
